import type { ComponentProps } from 'react';
import { Trans } from 'react-i18next';

/**
 * <Trans> for translations that contain markup (<strong>, links) and runtime values.
 *
 * The i18n instance sets `escapeValue: false` because React escapes what t() returns.
 * <Trans> is different: it parses the interpolated string into elements, so with
 * unescaped values, a value containing tags would become markup. SafeTrans escapes
 * values before parsing and unescapes the resulting text, so a value is always shown as
 * text. Use it instead of <Trans> everywhere.
 */
export default function SafeTrans(props: ComponentProps<typeof Trans>) {
  const { tOptions, ...rest } = props;
  return (
    <Trans
      {...rest}
      shouldUnescape
      tOptions={{ ...tOptions, interpolation: { ...tOptions?.interpolation, escapeValue: true } }}
    />
  );
}
